import { createContext } from 'react';

export type AuthContext = {
  isLoading: boolean;
  isAuthenticated: boolean;
  token: string | null;
};

export const AuthTokenContext = createContext<AuthContext>({
  isLoading: false,
  isAuthenticated: false,
  token: null,
});
